// Settings sagas - main entry point

import { fork, takeEvery, takeLatest } from 'redux-saga/effects';

// Actions
import {
  CreateLink,
  DeleteLink,
  SaveSlides,
  SetMarkup,
  SetTheme,
  UpdateAmbasador,
  UpdateLink,
  UserLogoutFromApp,
} from '@actions/user';

// Saga functions
import { UserLogoutFromAppSaga } from './authSagas';
import { SetMarkupSaga, SetThemeSaga } from './themeSagas';
import { CreateLinkSaga, DeleteLinkSaga, UpdateLinkSaga } from './linkSagas';
import { SaveSlidesSaga } from './slidesSagas';
import { UpdateAmbasadorSaga } from './ambassadorSagas';
import { PWADownloadSaga } from './pwaSagas';

// Re-export types
export * from './types';

// Re-export individual sagas for testing or direct usage
export { UserLogoutFromAppSaga } from './authSagas';
export { SetMarkupSaga, SetThemeSaga } from './themeSagas';
export { CreateLinkSaga, DeleteLinkSaga, UpdateLinkSaga } from './linkSagas';
export { SaveSlidesSaga } from './slidesSagas';
export { UpdateAmbasadorSaga } from './ambassadorSagas';
export { PWADownloadSaga } from './pwaSagas';
export { uploadImageSaga } from './utils';

function* settingsSaga(): Generator {
  yield takeEvery(CreateLink, CreateLinkSaga);
  yield takeEvery(UpdateLink, UpdateLinkSaga);
  yield takeEvery(DeleteLink, DeleteLinkSaga);
  yield takeEvery(UserLogoutFromApp, UserLogoutFromAppSaga);
  yield takeEvery(SetTheme, SetThemeSaga);
  yield takeLatest(SetMarkup, SetMarkupSaga);
  yield takeLatest(SaveSlides, SaveSlidesSaga);
  yield takeLatest(UpdateAmbasador, UpdateAmbasadorSaga);
  yield fork(PWADownloadSaga);
}

export default settingsSaga;
